export class CustomerAgreement {
    public isAvailableToAccept: boolean;
}
